import { Col, Container, Row } from "react-grid-system";
import {
  HeaderLabelText,
  LabelText,
  SmallLabelText,
  StyledVisualInspectionPage,
  TitleLabelText,
} from "./ThirdPartyVisualInspectionPage.styles";
import {
  NumericTextBoxComponent,
  TextBoxComponent,
} from "@syncfusion/ej2-react-inputs";
import { useAuth } from "../../utility/useAuth";
import { useEffect, useState } from "react";
import {
  createTicket,
  getDocumentContent,
  getDocuments,
  getOption,
  getPurchaseOrders,
  getUsers,
  lockAction,
  printTemplate,
  sendEmail,
  unlockAction,
  uploadDocument,
} from "../../services/ApiService";
import { ToastUtility } from "@syncfusion/ej2-react-notifications";
import {
  AutoCompleteComponent,
  ComboBoxComponent,
  Inject,
} from "@syncfusion/ej2-react-dropdowns";
import { useStoreState } from "../../store";
import { RecomendationType } from "../../types/reportChecklists/RecomendationType";
import {
  ButtonComponent,
  CheckBoxComponent,
} from "@syncfusion/ej2-react-buttons";
import { InpectionItem } from "../../types/reportChecklists/InspectionItem";
import {
  ColumnDirective,
  ColumnsDirective,
  Edit,
  GridComponent,
  Resize,
} from "@syncfusion/ej2-react-grids";
import { InspectionStatusType } from "../../types/reportChecklists/InspectionStatusType";
import { ItemsDirective } from "@syncfusion/ej2-react-navigations";
import AsyncModal from "../../components/Modals/AsyncModal/AsyncModal";
import { BarCodeScannerPanel } from "../../components/BarCodeScannerPanel/BarCodeScannerPanel";
import { ThirdPartyVisualInspectionReport } from "../../types/reportChecklists/ThirdPartyVisualInspectionReport";
import { useNavigate, useParams } from "react-router";
import { shortDateFormat } from "../../utility/dateHelpers";
import { Ticket } from "../../types/reportChecklists/Ticket";
import { InspectorRole } from "../../types/InspectorRole";
import { EmailMessage } from "../../types/EmailMessage";
import { PrintRequest } from "../../types/PrintRequest";

export const ThirdPartyVisualInspectionPage: React.FC = () => {
  const auth = useAuth();
  const user = useStoreState((state) => state.user);
  const { sequence } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState<string>();
  const [purchaseOrders, setPurchaseOrders] = useState<string[]>([]);
  const [purchaseOrder, setPurchaseOrder] = useState<string>();
  const [partNumber, setPartNumber] = useState<string>();
  const [heatCode, setHeatCode] = useState<string>();
  const [quantity, setQuantity] = useState<number>(1);
  const [rejectedQuantity, setRejectedQuantity] = useState<number>();
  const [sequenceNumber, setSequenceNumber] = useState<string>();
  const [batch, setBatch] = useState<number>(1);
  const [iteration, setIteration] = useState<string>("A");
  const [status, setStatus] = useState<string>();
  const [pugseyTestReportNumber, setPugseyTestReportNumber] =
    useState<string>();
  const [measurementReportNumber, setMeasurementReportNumber] =
    useState<string>();
  const [assemblyDrawingNumber, setAssemblyDrawingNumber] = useState<string>();
  const [revision, setRevision] = useState<string>();
  const [recommendation, setRecommendation] = useState<string>();
  const [documentCheckListItems, setDocumentCheckListItems] = useState<
    InpectionItem[]
  >([]);
  const [visualCheckListItems, setVisualCheckListItems] = useState<
    InpectionItem[]
  >([]);
  const [recommendationCheckListItems, setRecommendationCheckListItems] =
    useState<InpectionItem[]>([]);
  //const [batchIdentification, setBatchIdentification] = useState<string>();
  const [nonConformanceReportRef, setNonConformanceReportRef] =
    useState<string>();
  const [reworkDescription, setReworkDescription] = useState<string>();
  const [inspectorSignature, setInspectorSignature] = useState<string>();
  const [inspectorSignDate, setInspectorSignDate] = useState<Date | undefined>(
    undefined
  );
  const [qualityRepresentiveSignature, setQualityRepresentiveSignature] =
    useState<string>();
  const [qualityRepresentiveSignDate, setQualityRepresentiveSignDate] =
    useState<Date | undefined>(undefined);
  const [warehouseRepresentiveSignature, setWarehouseRepresentiveSignature] =
    useState<string>();
  const [warehouseRepresentiveSignDate, setWarehouseRepresentiveSignDate] =
    useState<Date | undefined>(undefined);
  const [canSumbit, setCanSubmit] = useState<boolean>(false);
  const [readOnly, setReadOnly] = useState<boolean>(false);

  const [printerName, setPrinterName] = useState<string>();
  const [lockInspectionMinutes, setLockInspectionMinutes] =
    useState<number>(10);

  let btnScanPartNumber: ButtonComponent | null;
  let btnScanHeatCode: ButtonComponent | null;

  const recomendations = [
    RecomendationType[RecomendationType.TotalRejection],
    RecomendationType[RecomendationType.PartialRejection],
    RecomendationType[RecomendationType.LocalRework],
    RecomendationType[RecomendationType.Approval],
  ];

  const reportType = "third-party-visual-inspection";
  const reportDescription = "3rd party visual inspection";

  const documentCheckList = [
    "Confirm that the part has a signed and approved measurement report form HydraPower ",
  ];

  const visualCheckList = [
    "Free from Burs",
    "Free from Particulate",
    "Free from Water",
    "Free from Water spots",
    "Free from Oil / grease / dust debris",
    "Free from Loose particles",
    "Free from Visible residue",
    "Free from Scratches / dents / damage",
  ];

  const recommendationCheckList = ["Cap both tube ends"];

  useEffect(() => {
    const visualCheckItems = visualCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setVisualCheckListItems(visualCheckItems);
    const documentCheckItems = documentCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setDocumentCheckListItems(documentCheckItems);
    const recommendationCheckItems = recommendationCheckList.map((v, i) => {
      return { seq: i + 1, text: v, status: "" } as InpectionItem;
    });
    setRecommendationCheckListItems(recommendationCheckItems);
    setInspectorSignature(user.info.name ?? user.fullName);
    setInspectorSignDate(new Date());
    /*if (user.info.inspection === InspectorRole[InspectorRole.Inspector]) {
      setInspectorSignature(user.info.name ?? user.fullName);
      setInspectorSignDate(new Date());
    }  else if (
      user.info.inspection === InspectorRole[InspectorRole.QualityRepresentive]
    ) {
      setQualityRepresentiveSignature(user.info.name ?? user.fullName);
      setQualityRepresentiveSignDate(new Date());
    } else if (
      user.info.inspection ===
      InspectorRole[InspectorRole.WarehouseRepresentive]
    ) {
      setWarehouseRepresentiveSignature(user.info.name ?? user.fullName);
      setWarehouseRepresentiveSignDate(new Date());
    } */

    getPurchaseOrders(auth)
      .then((po) => {
        setPurchaseOrders(po);
      })
      .catch((error) => {
        const message = `Failed to get purchase orders. Error: ${error}`;
        console.error(message);
        ToastUtility.show(message, "Error", 2000);
      });

    getOption(auth, `LabelPrinter:${user.info.printLocation}`).then(
      (option) => {
        setPrinterName(option);
      }
    );

    getOption(auth, `LockInspectionMinutes`).then((option) => {
      if (option) {
        setLockInspectionMinutes(Number(option));
      }
    });
  }, []);

  useEffect(() => {
    if (sequence) {
      if (
        user.info.inspection !==
          InspectorRole[InspectorRole.QualityRepresentive] &&
        user.info.inspection !==
          InspectorRole[InspectorRole.WarehouseRepresentive]
      ) {
        setError(
          "You need to be Quality or Warehouse Representive to countersign the report."
        );
        return;
      }

      if (
        user.info.inspection ===
        InspectorRole[InspectorRole.QualityRepresentive]
      ) {
        setQualityRepresentiveSignature(user.info.name ?? user.fullName);
        setQualityRepresentiveSignDate(new Date());
      } else if (
        user.info.inspection ===
        InspectorRole[InspectorRole.WarehouseRepresentive]
      ) {
        setWarehouseRepresentiveSignature(user.info.name ?? user.fullName);
        setWarehouseRepresentiveSignDate(new Date());
      }
      loadReport(sequence, false);
    }
  }, [sequence]);

  useEffect(() => {
    if (partNumber) {
      const sequenceNumber = `${partNumber}-${batch}-${iteration}${
        status ? `-${status}` : ""
      }`;
      setSequenceNumber(sequenceNumber);
    }
  }, [partNumber, batch, iteration, status]);

  useEffect(() => {
    const documentStatus = validateItems(documentCheckListItems);
    const visualStatus = validateItems(visualCheckListItems);
    const recomendationStatus = validateItems(recommendationCheckListItems);
    setStatus(undefined);
    setCanSubmit(false);
    if (
      !purchaseOrder ||
      !heatCode ||
      !pugseyTestReportNumber ||
      !measurementReportNumber || 
      !assemblyDrawingNumber
    ) {
      return;
    }
    if (
      documentStatus === true &&
      visualStatus === true &&
      recomendationStatus === true &&
      partNumber &&
      recommendation === RecomendationType[RecomendationType.Approval]
    ) {
      setStatus("P");
      setCanSubmit(true);
    }
    if (
      partNumber &&
      (documentStatus === false ||
        visualStatus === false ||
        recomendationStatus === false) &&
      (recommendation === RecomendationType[RecomendationType.TotalRejection] ||
        iteration === "D")
    ) {
      setStatus("F");
      setCanSubmit(true);
    } else if (
      partNumber &&
      (documentStatus === false ||
        visualStatus === false ||
        recomendationStatus === false) &&
      (recommendation ===
        RecomendationType[RecomendationType.PartialRejection] ||
        recommendation === RecomendationType[RecomendationType.LocalRework])
    ) {
      setStatus("R");
      setCanSubmit(true);
    }
  }, [
    purchaseOrder,
    heatCode,
    pugseyTestReportNumber,
    measurementReportNumber,
    assemblyDrawingNumber,
    partNumber,
    documentCheckListItems,
    visualCheckListItems,
    recommendationCheckListItems,
    recommendation,
  ]);

  function loadReport(sequence: string, rework: boolean) {
    if (
      sequence &&
      documentCheckListItems &&
      visualCheckListItems &&
      recommendationCheckListItems
    ) {
      const parts = sequence.split("-");
      const partNumber = parts
        .slice(0, parts.length - 3)
        .join("-")
        .toUpperCase();
      const batch = Number(parts[parts.length - 3]);
      const iteration = parts[parts.length - 2].toUpperCase();
      const status = parts[parts.length - 1];
      const reportName = `${batch}-${iteration}-${status}`;

      const newIteration = rework
        ? String.fromCharCode(iteration.charCodeAt(0) + 1)
        : iteration;
      if (!rework) {
        lockAction(
          auth,
          `${partNumber} ${reportDescription}`,
          lockInspectionMinutes
        ).catch((error) => {
          setError(`${error.response.data}`);
          return;
        });
      }

      getReport(partNumber.toLowerCase(), reportName.toLowerCase()).then(
        (report) => {
          if (!report) {
            setError("Failed to load the report");
            return;
          }

          const signedBy = user.info.name ?? user.fullName;
          if (!rework && report?.inspectorSignature === signedBy) {
            setError(
              "You can't countersign the report that you already signed"
            );
            return;
          }

          setPurchaseOrder(report?.purchaseOrder);
          setHeatCode(report?.heatCode);
          setPugseyTestReportNumber(report?.pugseyTestReportNumber);
          setMeasurementReportNumber(report?.measurementReportNumber);
          setAssemblyDrawingNumber(report?.assemblyDrawingNumber);
          setRevision(report?.revision);
          setQuantity(report?.quantity);

          // Workaround for UI Grid issue
          if (
            report.documentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            documentCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setDocumentCheckListItems(
              report?.documentCheckListItems ?? documentCheckListItems
            );
          }

          // Workaround for UI Grid issue
          if (
            report.visualCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            visualCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setVisualCheckListItems(
              report?.visualCheckListItems ?? visualCheckListItems
            );
          }

          // Workaround for UI Grid issue
          if (
            report.recommendationCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            ) ||
            recommendationCheckListItems.some(
              (i) =>
                i.status === InspectionStatusType[InspectionStatusType.Pass] ||
                i.status ===
                  InspectionStatusType[InspectionStatusType.Reject] ||
                i.status === InspectionStatusType[InspectionStatusType.Rework]
            )
          ) {
            setRecommendationCheckListItems(
              report?.recommendationCheckListItems ??
                recommendationCheckListItems
            );
          }

          setRecommendation(report?.recommendation);
          //setBatchIdentification(report?.batchIdentification);
          setNonConformanceReportRef(report?.nonConformanceReportRef);
          setReworkDescription(report?.reworkDescription);
          setRejectedQuantity(report?.rejectedQuantity);
          if (rework) {
            setInspectorSignature(user.info.name ?? user.fullName);
            setInspectorSignDate(new Date());
          } else {
            setInspectorSignature(report?.inspectorSignature);
            setInspectorSignDate(report?.inspectorSignDate);
          }

          if (report?.qualityRepresentiveSignature) {
            setQualityRepresentiveSignature(
              report?.qualityRepresentiveSignature
            );
            setQualityRepresentiveSignDate(report?.qualityRepresentiveSignDate);
          }

          if (report?.warehouseRepresentiveSignature) {
            setWarehouseRepresentiveSignature(
              report?.warehouseRepresentiveSignature
            );
            setWarehouseRepresentiveSignDate(
              report?.warehouseRepresentiveSignDate
            );
          }

          setPartNumber(partNumber);
          setBatch(batch);
          setIteration(newIteration);
          setStatus(status);
          setSequenceNumber(sequence.toUpperCase());
        }
      );
    }
  }

  const mergeInspectionItems = (
    items1: InpectionItem[],
    items2: InpectionItem[] | undefined
  ): InpectionItem[] => {
    if (!items2 || items2.length === 0) {
      return items1;
    }
    return items1.map((i) => {
      const item = items2.find((it) => it.seq === i.seq);
      return item ?? i;
    });
  };

  const validateItems = (
    inspectionItems: InpectionItem[]
  ): boolean | undefined => {
    if (
      inspectionItems?.some(
        (it) => it.status === InspectionStatusType[InspectionStatusType.Reject]
      )
    ) {
      return false;
    }

    if (
      inspectionItems?.every(
        (it) =>
          it.status === InspectionStatusType[InspectionStatusType.Pass] ||
          it.status === InspectionStatusType[InspectionStatusType.Rework]
      )
    ) {
      return true;
    }
    return undefined;
  };

  const documentCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (documentCheckListItems) {
              const items = [
                ...documentCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setDocumentCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const visualCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          //disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (visualCheckListItems) {
              const items = [
                ...visualCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setVisualCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const recommendationCheckBoxTemplate = (props: any) => {
    return (
      <div>
        <CheckBoxComponent
          disabled={readOnly}
          checked={
            props.status === InspectionStatusType[InspectionStatusType.Pass] ||
            props.status === InspectionStatusType[InspectionStatusType.Rework]
              ? true
              : props.status ===
                InspectionStatusType[InspectionStatusType.Reject]
              ? false
              : undefined
          }
          indeterminate={
            props.status !== InspectionStatusType[InspectionStatusType.Pass] &&
            props.status !==
              InspectionStatusType[InspectionStatusType.Rework] &&
            props.status !== InspectionStatusType[InspectionStatusType.Reject]
          }
          onChange={(args: any) => {
            if (recommendationCheckListItems) {
              const items = [
                ...recommendationCheckListItems.map((item) => {
                  if (item.seq === props.seq) {
                    item.status = args.target.checked
                      ? InspectionStatusType[InspectionStatusType.Pass]
                      : InspectionStatusType[InspectionStatusType.Reject];
                    item.user = user?.info?.name ?? user.fullName;
                    item.date = new Date();
                  }
                  return item;
                }),
              ];
              setRecommendationCheckListItems(items);
            }
          }}
        />
        {"  "}
        {props.status}
        {"  "}
        {props.user}
        {"  "}
        {props.date ? shortDateFormat(props.date) : ""}
      </div>
    );
  };

  const scanPartNumberClick = async (event: any) => {
    const dataResult = await AsyncModal.open<string>({
      onHide: () => console.log("On hide"),
      cancelValue: "",
      confirmValue: "",
      children: <BarCodeScannerPanel />,
    });

    if (dataResult) {
      try {
        await lockAction(
          auth,
          `${dataResult} ${reportDescription}`,
          lockInspectionMinutes
        );
      } catch (error: any) {
        setError(`${error.response.data}`);
        return;
      }

      const batch = await getPartNumberBatch(dataResult);
      if (batch[0]) {
        setBatch(batch[0]);
      } else if (batch[1]) {
        loadReport(`${dataResult}-${batch[1]}`, true);
      }

      setPartNumber(dataResult);
    }
  };

  const scanHeatCodeClick = async (event: any) => {
    const dataResult = await AsyncModal.open<string>({
      onHide: () => console.log("On hide"),
      cancelValue: "",
      confirmValue: "",
      children: <BarCodeScannerPanel />,
    });

    if (dataResult) {
      setHeatCode(dataResult);
    }
  };

  function handleError(error: any, prefix?: string) {
    const message = `${prefix} Error: ${error}`;
    console.error(message);
    ToastUtility.show(message, "Error", 2000);
  }

  async function getReport(
    partNumber: string,
    report: string
  ): Promise<ThirdPartyVisualInspectionReport | undefined> {
    try {
      const result = await getDocumentContent(
        auth,
        `${reportType}-reports-${partNumber}`,
        report
      );
      return JSON.parse(
        await result.text()
      ) as ThirdPartyVisualInspectionReport;
    } catch (error) {
      handleError(error, "Failed to retrieve report");
    }
    return undefined;
  }

  async function getPartNumberBatch(
    partNumber: string
  ): Promise<[number | undefined, string | undefined]> {
    try {
      const reports = (
        await getDocuments(
          auth,
          undefined,
          `third-party-visual-inspection-reports-${partNumber.toLowerCase()}`,
          true
        )
      ).map((d) => {
        return {
          batch: Number(d.split("\\")[1].split("-")[0]),
          iteration: d.split("\\")[1].split("-")[1],
          status: d.split("\\")[1].split("-")[2],
        };
      });
      //const maxBatch = Math.max(...reports.map((o) => o.batch), 0);
      if (reports?.length > 0) {
        const lastReport = reports.reduce(
          ([max], item) => [
            max.batch * 100 + max.iteration.charCodeAt(0) <
            item.batch * 100 + item.iteration.charCodeAt(0)
              ? item
              : max,
          ],
          [reports[0]]
        );

        if (lastReport?.length > 0 && lastReport[0].status === "r") {
          return [
            undefined,
            `${lastReport[0].batch}-${lastReport[0].iteration}-${lastReport[0].status}`,
          ];
        }

        return [lastReport[0].batch + 1, undefined];
      }

      //return Math.max(...reports.map((o) => o.batch), 0) + 1;
    } catch (error) {
      handleError(error, "Failed to get reports");
    }
    return [1, undefined];
  }

  const printLabel = async (report: ThirdPartyVisualInspectionReport) => {
    if (!printerName) {
      return;
    }

    const substr: {
      [key: string]: string;
    } = {};

    Object.entries(report).forEach(
      ([key, value]) =>
        (substr[`Report.${key}`] =
          value instanceof Date === true
            ? shortDateFormat(value?.toString() ?? "")
            : value.toString() ?? "")
    );

    console.log(JSON.stringify(substr));

    const request: PrintRequest = {
      templateName: `templates-labelprinter\\thirdpartyvisualinspectionreport.xml`,
      substrings: substr,
      noLabels: 1,
      printerName: printerName,
      location: user.info.printLocation,
    };

    try {
      const data = await printTemplate(auth, request);
      ToastUtility.show("The print job sent to the spooler.", "Info", 2000);
    } catch (error) {
      handleError(error, "Failed to print label operation.");
    }
  };

  const onSubmit = async (event: any) => {
    const report: ThirdPartyVisualInspectionReport = {
      purchaseOrder: purchaseOrder ?? "",
      partNumber: partNumber ?? "",
      heatCode: heatCode ?? "",
      quantity: quantity,
      rejectedQuantity: rejectedQuantity,
      pugseyTestReportNumber: pugseyTestReportNumber ?? "",
      measurementReportNumber: measurementReportNumber ?? "",
      assemblyDrawingNumber: assemblyDrawingNumber ?? "",
      revision: revision ?? "",
      documentCheckListItems: documentCheckListItems,
      visualCheckListItems: visualCheckListItems,
      recommendationCheckListItems: recommendationCheckListItems,
      recommendation: recommendation ?? "",
      //batchIdentification: batchIdentification ?? "",
      nonConformanceReportRef: nonConformanceReportRef,
      reworkDescription: reworkDescription,
      inspectorSignature: inspectorSignature ?? "",
      inspectorSignDate: inspectorSignDate ?? new Date(),
    };

    if (
      !nonConformanceReportRef &&
      (recommendation === RecomendationType[RecomendationType.TotalRejection] ||
        recommendation ===
          RecomendationType[RecomendationType.PartialRejection])
    ) {
      const ticket: Ticket = {
        subject: `FAILED TUBE SET ${partNumber}-${batch}-${iteration}`,
        content: reworkDescription!,
      };
      report.nonConformanceReportRef = await createTicket(auth, ticket);
    }

    const blob = new Blob([JSON.stringify(report, null, 2)], {
      type: "application/json",
    });

    const reportName = `${batch}-${iteration}${status ? `-${status}` : ""}`;

    try {
      await uploadDocument(
        auth,
        `${reportType}-reports-${partNumber}`,
        reportName,
        blob
      );

      unlockAction(auth, `${partNumber}  ${reportDescription}`).catch((error) => {
        handleError(error, "Failed to unlock the report");
        return;
      });

      const needQualityRepSignature: boolean =
        !report.qualityRepresentiveSignature;
      const needWarehouseRepSignature: boolean =
        !report.warehouseRepresentiveSignature;
      if (status === "P") {
        await printLabel(report);

        if (needQualityRepSignature || needWarehouseRepSignature) {
          const users = (await getUsers(auth)).filter(
            (u) =>
              (needQualityRepSignature &&
                u.inspection ===
                  InspectorRole[InspectorRole.QualityRepresentive]) ||
              (needWarehouseRepSignature &&
                u.inspection ===
                  InspectorRole[InspectorRole.WarehouseRepresentive])
          );

          const subject = `Countersign ${reportName} report`;
          const body = `Dear Sir or Madam,<br/>Please countersign ${reportName} report.<br/>
        <a>https://csm.swagelokcentral.co.uk/${reportType}/${partNumber}-${reportName}</a>`;

          const currentUser = user.info.name ?? user.fullName;

          users.forEach((user) => {
            if (user.email && currentUser !== user.name) {
              try {
                let email: EmailMessage = {
                  subject: subject,
                  body: body,
                  to: [{ address: user.email }],
                };
                sendEmail(auth, email);
              } catch (emailError) {
                handleError(emailError, "Failed to send email");
              }
            }
          });
        }
      }
      navigate(`/barcode/${sequenceNumber?.toLowerCase()}`);
    } catch (error) {
      handleError(error, "Failed to submit report");
    }
  };

  return (
    <StyledVisualInspectionPage>
      {error ? (
        <div className="text-danger">
          <h1>Error: {error}</h1>
        </div>
      ) : (
        <Container fluid>
          <Row align="stretch">
            <h1 style={{ margin: "auto" }}>
              Third Party Visual Inspection Acceptance Report Checklist (Batch
              1)
            </h1>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>PURCHASE ORDER:</LabelText>
            </Col>
            <Col>
              <AutoCompleteComponent
                id="atcelement"
                dataSource={purchaseOrders}
                placeholder="Enter purchase order"
                value={purchaseOrder}
                readOnly={readOnly}
                onChange={(args: any) => {
                  setPurchaseOrder(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>PART NUMBER:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                value={partNumber}
                placeholder="Scan part number"
                /* input={async (args: any) => {
                  try {
                    await lockAction(
                      auth,
                      `${args?.value} visual inspection`,
                      lockInspectionMinutes
                    );
                  } catch (error: any) {
                    setError(`${error.response.data}`);
                    return;
                  }
                  const batch = await getPartNumberBatch(args?.value);
                  if (batch[0]) {
                    setBatch(batch[0]);
                  } else if (batch[1]) {
                    loadReport(`${args?.value}-${batch[1]}`, true);
                  }
                  setPartNumber(args?.value);
                }} */
                readOnly
              />
            </Col>
            <Col sm={1}>
              <ButtonComponent
                ref={(scope : ButtonComponent) => {
                  btnScanPartNumber = scope;
                }}
                disabled={readOnly}
                cssClass="e-inherit"
                iconCss="e-icons e-video"
                style={{ width: "50px" }}
                onClick={scanPartNumberClick}
                created={() => {
                  if (btnScanPartNumber) {
                    btnScanPartNumber.element.setAttribute(
                      "title",
                      "Scan Part Number"
                    );
                  }
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>HEAT CODE:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                value={heatCode}
                placeholder="Scan heat code"
                readOnly
              />
            </Col>
            <Col sm={1}>
              <ButtonComponent
                ref={(scope: ButtonComponent) => {
                  btnScanHeatCode = scope;
                }}
                disabled={readOnly}
                cssClass="e-inherit"
                iconCss="e-icons e-video"
                style={{ width: "50px" }}
                onClick={scanHeatCodeClick}
                created={() => {
                  if (btnScanHeatCode) {
                    btnScanHeatCode.element.setAttribute(
                      "title",
                      "Scan Heat Code"
                    );
                  }
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>QUANTITY:</LabelText>
            </Col>
            <Col>
              <NumericTextBoxComponent
                value={quantity}
                min={1}
                readonly={readOnly}
                onChange={(args: any) => {
                  setQuantity(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>SEQUENCE NUMBER:</LabelText>
            </Col>
            <Col>{sequenceNumber}</Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>PUGSEY TEST REPORT NUMBER:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                readOnly={readOnly}
                placeholder="Enter pugsey test repot number"
                value={pugseyTestReportNumber}
                onChange={(args: any) => {
                  setPugseyTestReportNumber(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>DOCUMENT VERIFICATION</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Measurement Report Number:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter measurement report number"
                value={measurementReportNumber}
                readOnly={readOnly}
                onChange={(args: any) => {
                  setMeasurementReportNumber(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Assembly Drawing No:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter assembly drawing number"
                value={assemblyDrawingNumber}
                onChange={(args: any) => {
                  setAssemblyDrawingNumber(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={4}>
              <LabelText>Rev:</LabelText>
            </Col>
            <Col>
              <TextBoxComponent
                placeholder="Enter revision"
                value={revision}
                readOnly={readOnly}
                onChange={(args: any) => {
                  setRevision(args?.value);
                }}
              />
            </Col>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="DocumentVerificationGrid"
              dataSource={documentCheckListItems}
              disabled={readOnly}
              height={50}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={documentCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>VISUAL VERIFICATION</TitleLabelText>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="VisualVerificationGrid"
              dataSource={visualCheckListItems}
              editSettings={{ allowEditing: true, mode: "Normal" }}
              //disabled={readOnly}
              height={320}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize, Edit]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  //type="boolean"
                  //displayAsCheckBox={true}
                  template={visualCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          <Row align="stretch">
            <TitleLabelText>
              3RD PARTY INSPECTION ACCEPTANCE TEST RECOMMENDATION
            </TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col>
              <LabelText>
                <b>Select recommendation in the box:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <ComboBoxComponent
                value={recommendation}
                disabled={readOnly}
                allowCustom={true}
                width="150"
                dataSource={recomendations}
                popupHeight="150"
                popupWidth="200"
                onChange={(args: any) => {
                  setRecommendation(args.value);
                }}
              ></ComboBoxComponent>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>1.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                The total rejection of the part number sequence, in which case
                HydraPower will need to remake (NCR number added)
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>2.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                Partial rejection, HydraPower to remake some of part number
                sequence.
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>3.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>Local rework</SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <Col sm={1}>
              <SmallLabelText>4.</SmallLabelText>
            </Col>
            <Col>
              <SmallLabelText>
                Approval to book into stock to be issued to assemblies
              </SmallLabelText>
            </Col>
          </Row>
          <Row align="stretch">
            <GridComponent
              id="RecommendationVerificationGrid"
              disabled={readOnly}
              dataSource={recommendationCheckListItems}
              height={50}
              gridLines="Both"
              allowResizing
            >
              <Inject services={[Resize]} />
              <ColumnsDirective>
                <ColumnDirective
                  field="seq"
                  isPrimaryKey={true}
                  headerText="Seq."
                  width="25"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="text"
                  headerText="Checklist"
                  textAlign="Left"
                  allowEditing={false}
                />
                <ColumnDirective
                  field="status"
                  width="100"
                  headerText="Status"
                  textAlign="Left"
                  type="boolean"
                  //displayAsCheckBox={true}
                  template={recommendationCheckBoxTemplate}
                  //editType="booleanedit"
                />
              </ColumnsDirective>
            </GridComponent>
          </Row>
          {recommendation ===
            RecomendationType[RecomendationType.TotalRejection] ||
          recommendation ===
            RecomendationType[RecomendationType.PartialRejection] ? (
            <>
              <Row align="stretch">
                <TitleLabelText>
                  3RD PARTY INSPECTION ACCEPTANCE TEST CHECKLIST FOR FAILED TUBE
                  SET
                </TitleLabelText>
              </Row>
              {recommendation ===
              RecomendationType[RecomendationType.PartialRejection] ? (
                <Row align="stretch">
                  <Col sm={4}>
                    <LabelText>
                      <b>REJECTED QUANTITY:</b>
                    </LabelText>
                  </Col>
                  <Col>
                    <NumericTextBoxComponent
                      value={rejectedQuantity}
                      readOnly={readOnly}
                      min={0}
                      max={quantity}
                      onChange={(args: any) => {
                        setRejectedQuantity(args?.value);
                      }}
                    />
                  </Col>
                </Row>
              ) : (
                <></>
              )}
              <Row align="stretch">
                <Col sm={3}>
                  <LabelText>
                    <b>BATCH IDENTIFICATION:</b>
                  </LabelText>
                </Col>
                <Col>
                  {batch && iteration ? `${batch}-${iteration}` : <></>}
                  {/* <TextBoxComponent
                  placeholder="Enter batch identification"
                  value={batchIdentification}
                  onChange={(args: any) => {
                    setBatchIdentification(args?.value);
                  }}
                /> */}
                </Col>
              </Row>
              <Row align="stretch">
                <TitleLabelText>
                  3RD PARTY INSPECTION TEST NON-CONFORMANCE REPORTING
                </TitleLabelText>
              </Row>
              <Row align="stretch">
                <Col sm={3}>
                  <LabelText>
                    <b>Non-Conformance Report Ref:</b>
                  </LabelText>
                </Col>
                <Col>
                  <TextBoxComponent value={nonConformanceReportRef} readOnly />
                </Col>
              </Row>
              <Row align="stretch">
                Provide brief description of the rework carried out here, if
                recommendation is rework can be carried out.
              </Row>
              <Row>
                <TextBoxComponent
                  // ref={(scope) => {
                  //   textareaObj = scope;
                  // }}
                  readOnly={readOnly}
                  multiline={true}
                  placeholder="Provide brief description of the rework carried out here, if
              recommendation is rework can be carried out."
                  value={reworkDescription}
                  // created={onCreate}
                  input={(args: any) => {
                    setReworkDescription(args?.value);
                  }}
                />
              </Row>
            </>
          ) : (
            <></>
          )}
          <Row align="stretch">
            <TitleLabelText>INSPECTOR SIGNATURE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{inspectorSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {inspectorSignDate !== undefined
                ? shortDateFormat(inspectorSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>QUALITY REPRESENTATIVE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{qualityRepresentiveSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {qualityRepresentiveSignDate !== undefined
                ? shortDateFormat(qualityRepresentiveSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <TitleLabelText>WAREHOUSE SIGNATURE</TitleLabelText>
          </Row>
          <Row align="stretch">
            <Col sm={2}>
              <LabelText>
                <b>Signed:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              <LabelText>{warehouseRepresentiveSignature}</LabelText>
            </Col>
            <Col sm={2}>
              <LabelText>
                <b>Date:</b>
              </LabelText>
            </Col>
            <Col sm={4}>
              {warehouseRepresentiveSignDate !== undefined
                ? shortDateFormat(warehouseRepresentiveSignDate?.toString())
                : ""}
            </Col>
          </Row>
          <Row align="stretch">
            <ButtonComponent
              disabled={!canSumbit}
              style={{ margin: "auto", width: "150px" }}
              cssClass="e-inherit"
              iconCss="e-icons e-save"
              onClick={onSubmit}
            >
              Submit
            </ButtonComponent>
          </Row>
        </Container>
      )}
    </StyledVisualInspectionPage>
  );
};
